// //index.js
// import Grid from "@mui/material/Grid";
// import Card from "@mui/material/Card";
// import MDBox from "components/MDBox";
// import MDTypography from "components/MDTypography";
// import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
// import DashboardNavbar from "examples/Navbars/DashboardNavbar";
// import Footer from "examples/Footer";
// import AccountTable from "layouts/tablessss/data/tablestructure";
// import useAccountsTableData from "layouts/tablessss/data/authorsTableData";
// import AccountInfoModal from "./data/AccountInfoModal";

// function Tables() {
//   const {
//     columns,
//     rows,
//     filterRole,
//     setFilterRole,
//     selectedAccount,
//     setSelectedAccount,
//   } = useAccountsTableData();

//   return (
//     <DashboardLayout>
//       <DashboardNavbar />
//       <MDBox pt={6} pb={3}>
//         <Grid container spacing={6}>
//           <Grid item xs={12}>
//             <Card>
//               <MDBox
//                 mx={2}
//                 mt={-3}
//                 py={3}
//                 px={2}
//                 variant="gradient"
//                 bgColor="warning"
//                 borderRadius="lg"
//                 coloredShadow="warning"
//               >
//                 <MDTypography variant="h6" color="white">
//                   Account List
//                 </MDTypography>
//               </MDBox>
//               <MDBox pt={3}>
//                 <AccountTable
//                   table={{ columns, rows }}
//                   isSorted
//                   entriesPerPage
//                   showTotalEntries
//                   canSearch
//                   noEndBorder
//                   filterRole={filterRole}
//                   setFilterRole={setFilterRole}
//                 />
//               </MDBox>
//             </Card>
//           </Grid>
//         </Grid>
//       </MDBox>

//       {/* Modal */}
//       <AccountInfoModal
//         open={!!selectedAccount}
//         account={selectedAccount}
//         onClose={() => setSelectedAccount(null)}
//       />

//       <Footer />
//     </DashboardLayout>
//   );
// }

// export default Tables;


//index.js
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import AccountTable from "layouts/tablessss/data/tablestructure";
import useAccountsTableData from "layouts/tablessss/data/authorsTableData";
import AccountInfoModal from "./data/AccountInfoModal";

function Tables() {
  const {
    columns,
    rows,
    filterRole,
    setFilterRole,
    selectedAccount,
    setSelectedAccount,
  } = useAccountsTableData();

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card
              sx={{
                // Height calculation adjusted to remove outer scrollbar
                // 100vh (Screen) - ~300px (Navbar + Footer + Padding + Margins)
                height: "calc(100vh - 300px)", 
                display: "flex",
                flexDirection: "column",
                // overflow: "hidden", 
              }}
            >
              {/* Header Section */}
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                // variant="gradient"
                // bgColor="warning"
                borderRadius="lg"
                // coloredShadow="warning"
                  sx={{
                  flexShrink: 0,
                  background:
                    "linear-gradient(135deg, rgba(19,152,220,0.75), rgba(15,120,176,0.75))",
                  boxShadow: "0 4px 18px rgba(19,152,220,0.35)",
                }}
              >
                <MDTypography variant="h6" color="white">
                  Account List
                </MDTypography>
              </MDBox>

              {/* Table Wrapper Section */}
              <MDBox 
                pt={3} 
                sx={{ 
                  flex: 1,           // Take all remaining height
                  overflow: "hidden", // Disable scroll here (handled inside AccountTable)
                  display: "flex",
                  flexDirection: "column",
                  minHeight: 0 // Crucial for nested flex scrolling
                }}
              >
                <AccountTable
                  table={{ columns, rows }}
                  isSorted
                  entriesPerPage
                  showTotalEntries
                  canSearch
                  noEndBorder
                  filterRole={filterRole}
                  setFilterRole={setFilterRole}
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>

      {/* Modal */}
      <AccountInfoModal
        open={!!selectedAccount}
        account={selectedAccount}
        onClose={() => setSelectedAccount(null)}
      />

      <Footer />
    </DashboardLayout>
  );
}

export default Tables;